import { ChangeDetectionStrategy, Component, inject, NgModule, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent, IS_DEVELOPMENT } from '@pro-connect/shared';
import { WwwAppState } from '../../../../models';
import { NgxsModule, select, Store } from '@ngxs/store';
import { AccountState, AccountStateRecalculateSummary } from './account.state';
import { Angulartics2GoogleTagManager } from 'angulartics2';

@NgModule({
  imports: [NgxsModule.forFeature([AccountState])],
})
class AccountStateLazyModule {}

@Component({
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, HeaderComponent, AccountStateLazyModule],
})
export class AccountComponent implements OnInit {
  public readonly user = select(WwwAppState.user);
  public readonly accountOrders = select(AccountState.events);
  private _store = inject(Store);
  protected readonly _isDevelopment = inject(IS_DEVELOPMENT);
  private readonly _angulartics2GoogleTagManager = inject(Angulartics2GoogleTagManager);

  public ngOnInit(): void {
    this._store.dispatch([new AccountStateRecalculateSummary()]);

    this._pushLayer(!!this.user(), 'pl', 'PL');
  }

  private _pushLayer(isLogged: boolean, language: string, country: string): void {
    this._angulartics2GoogleTagManager.pushLayer({
      brand: 'LDB',
      language: language,
      country: country,
      siteTypeLevel: this._isDevelopment ? 'test' : 'main',
      pageCategory: 'homepage',
      geoIPLocation: country,
      uiLoggedStatus: isLogged ? 'logged' : 'not logged',
      uiType: this.user()?.type,
    });
  }
}
